<template>
	<div class="deat_box">
		<div class="box_head p_b_b">
			<span class="type_size_22" v-html="title">}</span>
			<div class="p_flex p_f_a p_f_b p_m_t_20">
				<div class="p_flex p_f_1 one-overflow p_m_r_30">{{num?job_publish_name:enquire_date}}</div>
				<div class="p_flex type_size_16">
					<span class="subject_color">{{classLevel}}</span>
					<el-divider direction="vertical"></el-divider>
					<span class="subject_yellow">{{subject_def}}</span>
				</div>
			</div>
		</div>
		<div class="box_head " v-if="num?true:false">
			<span class="type_size_16 p_flex p_f_c">{{date}}</span>
			<div class="box_center p_m_t_20">
				<span class="type_size_16">{{subject_def}} : {{student_content}}</span>
			</div>
		</div>
		<div class="box_head " v-else v-show="teacher_content?true:false">
			<span class="type_size_16 p_flex p_f_c">{{date}}</span>
			<div class="box_center p_m_t_20">
				<span class="type_size_16">回答 : {{teacher_content}}</span>
			</div>
		</div>
		<div class="subject_color type_size_18" v-show="teacher_content && num?true:false">
			回答：{{teacher_content}}
		</div>
	</div>
</template>

<script>
export default {
	props:{
		v:String
	},
	data() {
		return{
			classLevel:"",
			title:"",
			subject_def:"",
			enquire_date:"",
			date:"",
			student_content:"",
			teacher_content:"",
			num:"",
			job_publish_name:""
		}
	},
	watch: {
		v:{
			handler(i,o){
				// console.log(i)
				this.teacher_content=i
			}
		}
	},
	created() {
		this.num=this.$route.query.num
		// console.log(this.$route.query.id)
		this.$request.ajax(this).post("/api_teacher/put_question_detail/"+this.$route.query.id).then(res=>{
			// console.log(res)
			this.classLevel=res.data.classLevel.name  //班级
			this.title=res.data.title     //名字
			this.subject_def=res.data.student.name   //学生名字
			this.enquire_date=res.data.enquire_date   //学生提问时间
			// this.date=this.moment(res.data.enquire_date).format("HH:mm")   //时间
			 this.date=res.data.enquire_date 
			this.student_content=res.data.student_content
			this.teacher_content=res.data.teacher_content
			this.job_publish_name=res.data.job_publish_name
			this.$emit("get",res.data.teacher_content)
		})
	},
	methods: {

	},
}
</script>

<style lang="scss" scoped>
.deat_box {
	padding: 0 260px;
}
.box_head {
	padding: 20px 0;
}
.box_center{
	background-color: #F5F5F5;
	padding: 30px;
	border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/news/commponents/errorDeatil.vue